enum childrenDisplayMode {
	None = 0,
	Panel = 1,
	Collapse = 2,
	SubChild = 3
}

export { childrenDisplayMode };
